// Privacy page describing anonymous analytics and controls
export function PrivacyPage() {
  return (
    <div className="pt-24 pb-20 px-6">
      <div className="mx-auto max-w-3xl">
        <h1 className="text-3xl font-bold mb-4">Privacy</h1>
        <p className="text-zinc-400 mb-6">
          We care about your privacy. This site uses anonymous, privacy-friendly analytics to understand
          how people use the mesh simulator and to improve the experience. No personal data is collected,
          and no cross-site tracking is performed.
        </p>

        <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-5 mb-6">
          <h2 className="text-xl font-semibold mb-2">What we track</h2>
          <ul className="list-disc ml-6 space-y-1 text-zinc-400">
            <li>Page views and time on page</li>
            <li>Simulator interactions such as pause/play and topology mode changes</li>
            <li>Playground mode entry/exit</li>
            <li>Clicks on external resources (e.g., Meshtastic documentation)</li>
          </ul>
          <p className="text-zinc-500 text-sm mt-3">
            These events are aggregated and cannot be used to identify you.
          </p>
        </div>

        <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-5 mb-6">
          <h2 className="text-xl font-semibold mb-2">How to opt out</h2>
          <p className="text-zinc-400">
            You can disable analytics at any time using the toggle in the site footer. Your choice is
            saved in your browser and respected across visits.
          </p>
        </div>

        <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-5 mb-6">
          <h2 className="text-xl font-semibold mb-2">Technology</h2>
          <p className="text-zinc-400">
            We use Umami, an open-source, privacy-friendly analytics platform. It does not use cookies
            to track you across the web. Data is collected in aggregate and retained for operational
            insight only.
          </p>
        </div>

        <p className="text-zinc-500 text-sm">
          Questions about privacy? Open an issue or contact the maintainers.
        </p>
      </div>
    </div>
  );
}


